module.exports = __webpack_public_path__ + "files/08f3e922cf0103b234bc77e655e1af23.png";